import {Formatter} from './units-formatter';

export class DecodedOusFormatter extends Formatter {
  apply(ous: string): string {
    if (ous) {
      const tokens = ous.split('_');

      if (tokens.length === 6) {
        return `uid://${tokens[3]}/${tokens[4]}/${tokens[5]}`;
      }
    }

    return ous;
  }
}
